export default __webpack_public_path__ + "static/media/Rerebrace of the Sanguine Disciple.490eafba.jpg";